import { MaybeNewTag, TagCellContext } from "./types";
import { Delete, Edit, KeyboardReturn } from "@mui/icons-material";

interface TagActionProps extends TagCellContext<unknown> {
  onDelete: (tag: MaybeNewTag) => Promise<void>;
}

export function TagActions({ row, isEditing, setIsEditing, onSave, onDelete }: TagActionProps) {
  return (
    <div className="flex flex-wrap items-center gap-1">
      {isEditing(row.id) ? (
        <>
          <button
            className="rounded-md border border-gray-200 text-gray-200 hover:bg-gray-200 hover:text-white min-h-6 px-2"
            onClick={() => setIsEditing(undefined)}>
            Cancel
          </button>
          <button
            className="rounded-md border border-peri-500 bg-peri-500 hover:bg-peri-700 text-white min-h-6 px-2"
            onClick={() => onSave(row.original)}>
            Save
            <KeyboardReturn className="w-3 h-3" />
          </button>
        </>
      ) : (
        <Edit
          tabIndex={0}
          className="h-4 w-4 text-gray-700 opacity-50 hover:opacity-100 cursor-pointer"
          onClick={() => setIsEditing(row.id)}
        />
      )}
      <Delete
        tabIndex={0}
        className="h-4 w-4 text-gray-700 opacity-50 hover:opacity-100 cursor-pointer"
        onClick={() => onDelete(row.original)}
      />
    </div>
  );
}
